export interface LeadSource {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_term: string;
  utm_content: string;
  referrer: string;
  path: string;
}

export const EMPTY_SOURCE: LeadSource = {
  utm_source: "",
  utm_medium: "",
  utm_campaign: "",
  utm_term: "",
  utm_content: "",
  referrer: "",
  path: "/",
};

const STORAGE_KEY = "qurtuba:source";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"] as const;

function readUtm(search: string): Partial<LeadSource> {
  const params = new URLSearchParams(search);
  const out: Partial<LeadSource> = {};
  for (const key of UTM_KEYS) {
    const value = params.get(key);
    if (value) out[key] = value.slice(0, 200);
  }
  return out;
}

function hasUtm(source: Partial<LeadSource>): boolean {
  return UTM_KEYS.some((key) => source[key] !== undefined && source[key] !== "");
}

function readStored(): Partial<LeadSource> {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed: unknown = JSON.parse(raw);
    return typeof parsed === "object" && parsed !== null ? (parsed as Partial<LeadSource>) : {};
  } catch {
    return {};
  }
}

function store(source: Partial<LeadSource>): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(source));
  } catch {
    return;
  }
}

export function readSource(
  location: { search: string; pathname: string; referrer?: string } = window.location,
): LeadSource {
  const fromUrl = readUtm(location.search);
  if (hasUtm(fromUrl)) store(fromUrl);
  const stored = hasUtm(fromUrl) ? fromUrl : readStored();

  return {
    utm_source: stored.utm_source ?? "",
    utm_medium: stored.utm_medium ?? "",
    utm_campaign: stored.utm_campaign ?? "",
    utm_term: stored.utm_term ?? "",
    utm_content: stored.utm_content ?? "",
    referrer: document.referrer.slice(0, 500),
    path: location.pathname,
  };
}
